
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CartItem } from '@softapps/wws/pos-core';
import { IsDefinedNotEmptyPipe } from '@softline/ui-core';

@Component({
  selector: 'soft-product-description-header',
  templateUrl: './product-description-header.component.html',
  styleUrl: './product-description-header.component.css',
  imports: [IsDefinedNotEmptyPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDescriptionHeaderComponent {
  readonly cartItem = input.required<CartItem>();
  readonly showAgeRestriction = input(true);
}
